module.exports = __webpack_public_path__ + "img/8C08EA1FAABFED598AA8860383AE86FA.8c08ea1f.png";